import { render, staticRenderFns } from "./exam-paper-practice.vue?vue&type=template&id=44e27c2b&scoped=true&"
import script from "./exam-paper-practice.vue?vue&type=script&lang=js&"
export * from "./exam-paper-practice.vue?vue&type=script&lang=js&"
import style0 from "./exam-paper-practice.vue?vue&type=style&index=0&id=44e27c2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e27c2b",
  null
  
)

export default component.exports